<template>
    <main class="layout__main--narrow layout__main--no-top-padding">
        <article
            v-if="!error"
            class="bleed"
        >
            <BaseSection
                v-if="!pending && page"
                class="container-narrow"
            >
                <template #title>
                    <h1>{{ page.title }}</h1>
                </template>

                <!-- eslint-disable vue/no-v-html -->
                <div
                    v-if="page.introText"
                    class="lead"
                    data-allow-anchor
                    v-html="page.introText"
                />
                <!-- eslint-enable vue/no-v-html -->

                <BaseNewsMeta :news="page" />
                <BasePillsList :pills="pills(page, event)" />
            </BaseSection>

            <BaseSection
                v-else-if="pending"
                class="container-narrow"
            >
                <template #title>
                    <h1>
                        <ContentPlaceholdersHeading :lines="2" />
                    </h1>
                </template>

                <p class="lead">
                    <ContentPlaceholdersText :lines="5" />
                </p>
                <div class="news-meta">
                    <ContentPlaceholdersText :lines="1" />
                </div>
                <div class="page__pills">
                    <ContentPlaceholdersText :lines="1" />
                </div>
            </BaseSection>

            <flexible-sections
                :sections="page ? page.sections : []"
                :placeholder="pending ? 'content' : undefined"
            />

            <BaseSection
                v-if="page"
                class="container-narrow"
            >
                <LazyBaseSocialLinks
                    type="article"
                    :hydrate-on-visible
                />
            </BaseSection>

            <BaseSection
                v-if="(tagIds && tagIds.length) || (topics && topics.length)"
                class="section--wide section--extra-spacing"
            >
                <template #title>
                    <h2>Suggested for you</h2>
                </template>

                <template #action>
                    <nuxt-link
                        to="/news"
                        aria-label="See all news"
                    >
                        See all <BaseIcon icon="chevron-right" />
                    </nuxt-link>
                </template>

                <template #default>
                    <RelatedNews
                        v-if="tagIds.length || topics.length"
                        :tags="tagIds"
                        :topics="topics"
                        :exclude-ids="[page.id]"
                    />
                </template>
            </BaseSection>
        </article>
    </main>
</template>

<script setup>
import DetailQuery from '~/graphql/queries/news/Detail.graphql';

const { activeSite } = useMultisite();
const { pills } = usePillsPage();
const { variables } = useCraftGraphqlSlug();

definePageMeta({
    middleware: 'news-routing'
});

const response = await useLazyAsyncQuery({
    query: DetailQuery,
    variables,
});

const {
    craftEntry: page,
    pending,
} = usePageQuery(
    response,
    { entryKey: 'page', activeSite }
);

const tagIds = computed(() => {
    if (toValue(page)?.tags) {
        return toValue(page)?.tags?.map(({ id }) => id);
    }
    return null;
});

const topics = computed(() => {
    if (toValue(page)?.topics) {
        return toValue(page)?.topics?.map(({ id }) => ({ id }));
    }
    return null;
});
</script>
